import React, { useEffect, useState } from "react";
import styles from "../../createEvent.module.css";
import { TopHeader } from "../../../TopHeader/TopHeader";
import { TextInput } from "evergreen-ui";
import { ParticipantRegistrationDetail } from "./ParticipantRegistrationDetails";
import { ParticipantRegistrationModal } from "./ParticipantRegistrationModal/ParticipantRegistrationModal";
import { loadData } from "../../../../Utils/localStorage";
import { EventConfig } from "../../../EventConfig";
import { useNavigate } from "react-router-dom";
import { ButtonBorder } from "../../../../Components/Button/Buttons/ButtonBorder/ButtonBorder";
import { toast } from "react-toastify";

export const RegistrationDetailPage = ({
  payloadSecondry,
  handleFormSubmit,
  selectedParticipantForm,
  setSelectedParticipantForm,
  participantValueSecondry,
  dropDownFieldType,
  setShowParticipantReg,
  setStep
}) => {
  const navigate = useNavigate();
  const [participantValue, setParticipantValue] = useState({
    isParticipantRegAllowed: 0,
    isParticipantRegAllowedAfterEvent: 0,
    participantCount: "",
  });
  const [isDisabled, setIsDisabled] = useState(false);

  const handleValueSubmit = (e) => {
    const { name, value, type, checked } = e.target;
    name == "participantCount"
      ? setParticipantValue({
          ...participantValue,
          [name]: value.replace(/[^0-9]/g, ""),
        })
      : setParticipantValue({
          ...participantValue,
          [name]: value,
        });
  };
  //---------------------------------------------
  const [
    participantRegistrationFieldModal,
    setParticipantRegistrationFieldModal,
  ] = useState(false);

  const [activeRegistrationBtn, setActiveRegistrationBtn] = useState("");

  const [participantForm, setParticipantForm] = useState([]);

  const [selectedParticipantFormDetails, setSelectedParticipantFormDetails] =
    useState([]);

  const handleChangeAudienceDropdown = (selectedOption) => {
    setSelectedParticipantForm(selectedOption);
    getSelecteFormDetailApi(selectedOption.value);
  };
  const addParticipantRegistrationField = (newFields, existingformName) => {
    if (existingformName) {
      let updatedForms = [...selectedParticipantFormDetails, ...newFields];

      setSelectedParticipantFormDetails(updatedForms);
    }

    setParticipantRegistrationFieldModal(false);
  };
  const getFormList = () => {
    let payload = {
      club_id: loadData("Club_id"),
      user_id: loadData("Token"),
      request_by: EventConfig.requestBy,
      community_type: "AC_COMM",
      request_from: "event_participant",
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/event/get_exiting_form_list/`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "content-type": "application/json",
        Authorization: loadData("Auth"),
      },
    })
      .then((d) => d.json())
      .then((res) => {
        if (res?.success == true) {
          setParticipantForm(
            res?.data?.Form_list?.map((i, index) => {
              return {
                label: i?.form_name,
                value: i?.id,
              };
            })
          );
        }
      })
      .catch((err) => {});
  };

  const getSelecteFormDetailApi = (formId) => {
    let payload = {
      club_id: loadData("Club_id"),
      user_id: loadData("Token"),
      request_by: EventConfig.requestBy,
      community_type: "AC_COMM",
      form_id: formId,
      request_from: "event_participant",
    };

    fetch(`${process.env.REACT_APP_API_URL}/api/event/get_form_details_by_id`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "content-type": "application/json",
        Authorization: loadData("Auth"),
      },
    })
      .then((d) => d.json())
      .then((res) => {
        if (res?.success == true) {
          setSelectedParticipantFormDetails(
            res?.data?.map((i, index) => {
              return {
                label: i?.field_name,
                value: "",
                type: i?.field_type,
                fieldOrder: i?.event_form_id,
                isMandatory: i?.is_mandatory,
                options: i?.options,
                isVisible: i?.is_visible,
                isDelete: i?.is_deleted,
                formFieldId: i?.form_field_id,
              };
            })
          );
        }
      })
      .catch((err) => {
        console.error("API response error:", err.message || "Unknown error");
      });
  };
  const handleSubmit = () => {
    let payload = {
      ...payloadSecondry,
      is_participant_form: participantValue?.isParticipantRegAllowed,
    };
    if (
      participantValue?.isParticipantRegAllowed == 1 &&
      participantValue?.participantCount == ""
    ) {
      toast.error("Please select number of participant");
      return;
    } else if (
      participantValue?.isParticipantRegAllowed == 1 &&
      participantValue?.participantCount < 1
    ) {
      toast.error("Number of participant cannot be less than 1");
      return;
    } else if (
      participantValue?.isParticipantRegAllowed == 1 &&
      (selectedParticipantForm?.label === null ||
        Object.keys(selectedParticipantForm)?.length < 1)
    ) {
      toast.error("Please select participant form ");
      return;
    } else if (
      participantValue?.isParticipantRegAllowed == 1 &&
      Object.keys(selectedParticipantForm)?.length > 0
    ) {
      let tempForm = selectedParticipantFormDetails?.map((i, index) => {
        let tempOption = i?.options
          ?.filter((option) => option.label !== "")
          ?.map((j, idx) => {
            return j?.label;
          });
        return {
          field_name: i?.label,
          field_type: i?.type?.value,
          is_mandatory: i?.isMandatory,
          options: tempOption?.length > 0 ? tempOption : [],
          is_visible: i?.isVisible,
          is_deleted: i?.isDelete,
          status: i?.status ? 1 : 0,
          form_field_id: i?.formFieldId,
          field_order: index,
        };
      });
      payload["is_participant_allowed_after_start"] =
        participantValue?.isParticipantRegAllowedAfterEvent;
      payload["participant_count"] = participantValue?.participantCount;
      payload["participant_form_id"] = selectedParticipantForm?.value;
      payload["participant_form"] = tempForm;
    }
    setIsDisabled(true);
    handleFormSubmit(payload);
  };
  useEffect(() => {
    getFormList();
  }, []);
  useEffect(() => {
    getSelecteFormDetailApi(selectedParticipantForm?.value);
  }, [selectedParticipantForm]);
  useEffect(() => {
    setParticipantValue({
      isParticipantRegAllowed:
        participantValueSecondry?.isParticipantRegAllowed || 0,
      isParticipantRegAllowedAfterEvent:
        participantValueSecondry?.isParticipantRegAllowedAfterEvent || 0,
      participantCount: participantValueSecondry?.participantCount || "",
    });
  }, [participantValueSecondry]);

  return (
    <div className={styles.creatEventMainDiv}>
      <ParticipantRegistrationModal
        title={"Add New Field"}
        open={participantRegistrationFieldModal}
        onCloseModal={() => setParticipantRegistrationFieldModal(false)}
        dropDownFieldType={dropDownFieldType}
        activeRegistrationBtn={activeRegistrationBtn}
        setActiveRegistrationBtn={setActiveRegistrationBtn}
        selectedParticipantForm={selectedParticipantForm}
        addParticipantRegistrationField={addParticipantRegistrationField}
        getFormList={getFormList}
        selectedParticipantFormDetails={selectedParticipantFormDetails}
      />

      <div className={styles.mainDiv}>
        <div className={styles.titleDiv}>
          <p>Event Registration</p>
        </div>
        <div className={styles.displayFlexDiv}>
          <div>
            <label className={styles.labelFont}>Registration Allowed</label>
            <span className={styles.star}>*</span>
            <br />
            <div className={styles.radioMainDiv}>
              <span
                className={
                  participantValue?.isParticipantRegAllowed == 1
                    ? styles.radioDivActive
                    : styles.radioDiv
                }
              >
                <input
                  type="radio"
                  name="isParticipantRegAllowed"
                  value={1}
                  checked={participantValue?.isParticipantRegAllowed == 1}
                  onChange={handleValueSubmit}
                />
                <label className={styles.radioLabel}>Yes</label>
              </span>
              <span
                className={
                  participantValue?.isParticipantRegAllowed == 0
                    ? styles.radioDivActive
                    : styles.radioDiv
                }
              >
                <input
                  type="radio"
                  name="isParticipantRegAllowed"
                  value={0}
                  checked={participantValue?.isParticipantRegAllowed == 0}
                  onChange={handleValueSubmit}
                />
                <label className={styles.radioLabel}>No</label>
              </span>
            </div>
          </div>
          {participantValue?.isParticipantRegAllowed == 1 && (
            <div>
              <label className={styles.labelFont}>No. of participants</label>
              <span className={styles.star}>*</span>
              <br />
              <TextInput
                className={styles.inputText}
                name="participantCount"
                value={participantValue?.participantCount}
                onChange={handleValueSubmit}
                autoComplete="off"
                maxLength="50"
              />
            </div>
          )}
        </div>
        {participantValue?.isParticipantRegAllowed == 1 && (
          <div className={styles.displayFlexDiv}>
            <div>
              <label className={styles.labelFont}>
                Allow registration after event start
              </label>
              <span className={styles.star}>*</span>
              <br />
              <div className={styles.radioMainDiv}>
                <span
                  className={
                    participantValue?.isParticipantRegAllowedAfterEvent == 1
                      ? styles.radioDivActive
                      : styles.radioDiv
                  }
                >
                  <input
                    type="radio"
                    name="isParticipantRegAllowedAfterEvent"
                    value={1}
                    checked={
                      participantValue?.isParticipantRegAllowedAfterEvent == 1
                    }
                    onChange={handleValueSubmit}
                  />
                  <label className={styles.radioLabel}>Yes</label>
                </span>
                <span
                  className={
                    participantValue?.isParticipantRegAllowedAfterEvent == 0
                      ? styles.radioDivActive
                      : styles.radioDiv
                  }
                >
                  <input
                    type="radio"
                    name="isParticipantRegAllowedAfterEvent"
                    value={0}
                    checked={
                      participantValue?.isParticipantRegAllowedAfterEvent == 0
                    }
                    onChange={handleValueSubmit}
                  />
                  <label className={styles.radioLabel}>No</label>
                </span>
              </div>
            </div>
            <div></div>
          </div>
        )}
      </div>
      {participantValue?.isParticipantRegAllowed == 1 && (
        <ParticipantRegistrationDetail
          selectedParticipantForm={selectedParticipantForm}
          selectedParticipantFormDetails={selectedParticipantFormDetails}
          setSelectedParticipantFormDetails={setSelectedParticipantFormDetails}
          participantForm={participantForm}
          handleChangeAudienceDropdown={handleChangeAudienceDropdown}
          setActiveRegistrationBtn={setActiveRegistrationBtn}
          participantRegistrationFieldModal={participantRegistrationFieldModal}
          setParticipantRegistrationFieldModal={
            setParticipantRegistrationFieldModal
          }
          getFormList={getFormList}
        />
      )}

      <div className={styles.saveBtn}>
        <ButtonBorder
          text={"Back"}
          width={200}
          buttonHandler={() => {
            setShowParticipantReg(false);
            setStep( (step) => step -1)
          }}
        />
        <button
          disabled={isDisabled}
          className={styles.createBtn}
          style={{ width: "200px" }}
          onClick={() => {
            handleSubmit();
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
};
